var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProjEtapa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.127 10.837C10.127 10.4907 10.2682 10.1586 10.5196 9.91371C10.771 9.66882 11.1119 9.53125 11.4674 9.53125H15.9357C16.2913 9.53125 16.6322 9.66882 16.8836 9.91371C17.135 10.1586 17.2762 10.4907 17.2762 10.837V17.8134C17.2762 18.3444 16.6596 18.6535 16.2163 18.3449L13.7016 16.5951L11.1868 18.3449C10.7431 18.6539 10.127 18.3449 10.127 17.8139V10.837Z",
    fill: "#6796CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjEtapa);
export default __webpack_public_path__ + "static/media/IconProjEtapa.88d07ec9d183e1fc932f35cd9a80863b.svg";
export { ForwardRef as ReactComponent };